import message from '@web-common/components/UI/Message/SiriusMessage';
import React, { useImperativeHandle } from 'react';
import { apis, apiHolder as api } from 'api';
import { MailActions, useActions, useAppSelector } from '@web-common/state/createStore';
import PraiseIcon from '@web-common/components/UI/Icons/svgs/PraiseIcon';
import styles from '../mailInfo.module.scss';
import classnames from 'classnames';
import { getIn18Text } from 'api';
import { remWaittingId } from '@web-mail-write/util';
import { mailContentHasVar, textHaveVar } from '@web-mail-write/components/SendMail/utils';
const trackApi = api.api.requireLogicalApi(apis.dataTrackerApiImp);
const PraiseMailBtn = React.forwardRef((props, ref) => {
    const mailActions = useActions(MailActions);
    const curAccount = useAppSelector(state => { var _a; return (_a = state.mailReducer.currentMail) === null || _a === void 0 ? void 0 : _a.optSender; });
    const isMainAccount = curAccount === null || curAccount === void 0 ? void 0 : curAccount.isMainAccount;
    const infoStatus = useAppSelector(state => state.mailReducer.currentMail.status);
    const sender = useAppSelector(state => state.mailReducer.currentMail.sender);
    const currentMailTitle = useAppSelector(state => { var _a, _b; return (_b = (_a = state.mailReducer.currentMail) === null || _a === void 0 ? void 0 : _a.entry) === null || _b === void 0 ? void 0 : _b.title; });
    const currentMailId = useAppSelector(state => { var _a; return (_a = state.mailReducer.currentMail) === null || _a === void 0 ? void 0 : _a.cid; });
    const priaseMailShow = infoStatus === null || infoStatus === void 0 ? void 0 : infoStatus.praiseMailShow;
    const taskMailShow = infoStatus === null || infoStatus === void 0 ? void 0 : infoStatus.taskMailShow;
    const conferenceShow = infoStatus === null || infoStatus === void 0 ? void 0 : infoStatus.conferenceShow;
    const scheduleDate = useAppSelector(state => state.mailReducer.currentMail.scheduleDate);
    const isDyncGroupSend = useAppSelector(state => state.mailReducer.currentMail.isDyncGroupSend);
    const clickPriase = () => {
        var _a, _b;
        if (!isMainAccount)
            return;
        remWaittingId(currentMailId, true);
        trackApi.track('pcMail_click_writeMail_addPraiseLetter');
        trackApi.track('pcMail_click_addButton_writeMailPage', { buttonName: getIn18Text('BIAOYANGXIN') });
        const hasVar = textHaveVar(currentMailTitle);
        const contentHasVar = mailContentHasVar();
        if (hasVar.customVar || hasVar.systemVar || contentHasVar) {
            message.warning({
                content: '表扬邮件暂不支持插入变量',
            });
            return;
        }
        if (scheduleDate) {
            message.warning({
                content: getIn18Text('BIAOYANGYOUJIANZAN'),
            });
        }
        else {
            mailActions.doPraiseShow(true);
            mailActions.doPraiseMailSetting(true);
            const praiseMail = {
                winners: [],
                medalId: null,
                presentationWords: '',
                presenter: (_b = (_a = sender === null || sender === void 0 ? void 0 : sender.contact) === null || _a === void 0 ? void 0 : _a.contact) === null || _b === void 0 ? void 0 : _b.contactName,
            };
            mailActions.doPraiseMailChange(praiseMail);
        }
    };
    useImperativeHandle(ref, () => ({
        click: clickPriase,
    }));
    return props.hidden || priaseMailShow || taskMailShow || conferenceShow || isDyncGroupSend ? null : (React.createElement("div", { className: classnames(styles.btnWrapper, { [styles.disabled]: !isMainAccount }), onClick: clickPriase },
        React.createElement("span", { className: classnames(styles.btnIcon) },
            React.createElement(PraiseIcon, null)),
        React.createElement("span", { className: styles.btnText }, getIn18Text('BIAOYANGXIN'))));
});
export default PraiseMailBtn;
